import { Button, FormControl } from "@mui/material";
import { IResolutionSubmitProps } from "../types/interfaces/IResolutionSubmitProps";

//This component is responsible for rendering a resolution response submit button.
//Props: The submitEnabled boolean and onSubmitClick function are passed in from the caller.
const ResolutionSubmit: React.FC<IResolutionSubmitProps> = ({ submitEnabled, onSubmitClick }) => {
    return (
        <FormControl sx={{ paddingBottom: 1 }}>
            <Button
                onClick={onSubmitClick} 
                disabled={!submitEnabled} 
                variant="contained"
                sx={{ maxWidth: 100 }} >
                Submit
            </Button>
        </ FormControl>
    );
}

export default ResolutionSubmit;